import { apiClient } from './client';
import type {
  BudgetWorkspace,
  CreateBudgetLineItemPayload,
  UpdateBudgetLineItemPayload,
  UpsertBudgetPayload,
} from '@/types/budget.types';

class BudgetService {
  async getWorkspace(celebrationId: number): Promise<BudgetWorkspace> {
    const response = await apiClient.get(`/celebrations/${celebrationId}/budget`);
    return response.data.data;
  }

  async upsertBudget(celebrationId: number, payload: UpsertBudgetPayload): Promise<BudgetWorkspace> {
    const response = await apiClient.put(`/celebrations/${celebrationId}/budget`, payload);
    return response.data.data;
  }

  async createLineItem(
    celebrationId: number,
    payload: CreateBudgetLineItemPayload,
  ): Promise<BudgetWorkspace> {
    const response = await apiClient.post(`/celebrations/${celebrationId}/budget/line-items`, payload);
    return response.data.data;
  }

  async updateLineItem(
    celebrationId: number,
    lineItemId: number,
    payload: UpdateBudgetLineItemPayload,
  ): Promise<BudgetWorkspace> {
    const response = await apiClient.patch(
      `/celebrations/${celebrationId}/budget/line-items/${lineItemId}`,
      payload,
    );
    return response.data.data;
  }

  async deleteLineItem(celebrationId: number, lineItemId: number): Promise<BudgetWorkspace> {
    const response = await apiClient.delete(`/celebrations/${celebrationId}/budget/line-items/${lineItemId}`);
    return response.data.data;
  }
}

export const budgetService = new BudgetService();
